import { shallowRef, ref, onMounted, onBeforeUnmount } from "vue";
import * as echarts from "echarts/core";
function useEChart() {
  const chartObj = shallowRef();
  const chartContainer = ref();
  const setChartOption = (chartOption) => {
    var _a;
    (_a = chartObj.value) == null ? void 0 : _a.setOption(chartOption);
  };
  const resizeChart = () => {
    var _a;
    (_a = chartObj.value) == null ? void 0 : _a.resize();
  };
  const clearChart = () => {
    var _a;
    (_a = chartObj.value) == null ? void 0 : _a.clear();
  };
  const getChartRect = () => {
    var _a, _b;
    return {
      width: (_a = chartObj.value) == null ? void 0 : _a.getWidth(),
      height: (_b = chartObj.value) == null ? void 0 : _b.getHeight()
    };
  };
  const addChartEvent = (name, callback) => {
    var _a;
    (_a = chartObj.value) == null ? void 0 : _a.on(name, callback);
    return () => {
      var _a2;
      (_a2 = chartObj.value) == null ? void 0 : _a2.off(name, callback);
    };
  };
  const dispatchAction = (payload) => {
    var _a;
    (_a = chartObj.value) == null ? void 0 : _a.dispatchAction(payload);
  };
  onMounted(() => {
    chartObj.value = echarts.init(chartContainer.value);
    window.addEventListener("resize", resizeChart);
  });
  onBeforeUnmount(() => {
    window.removeEventListener("resize", resizeChart);
  });
  return {
    setChartOption,
    resizeChart,
    clearChart,
    getChartRect,
    addChartEvent,
    chartContainer,
    dispatchAction
  };
}
export { useEChart };
